export default {
  data() {
    return {
      tableRowIndices: {},
    };
  },
  computed: {
    preferences() {
      return this.$store.getters.preferences;
    }
  },
  methods: {
    prepTableRowIndices() {
      if (this.preferences && this.preferences.tableRowIndices) {
        this.tableRowIndices = this.preferences.tableRowIndices;
      }
    },
    // Note: Using this method depends on 2 conventions.
    // If filterName is 'myLib' then you need a table key called
    // "myLibKey" and a data property called "myLibFilter"
    loadFilter(filterName, filterVal) {
      this[filterName + 'Filter'] = filterVal;

      // Save to localStorage
      const newFilter = {};
      newFilter[filterName + 'Filter'] = this[filterName + 'Filter'];
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, newFilter)
      );

      // Force an update
      this[filterName + 'Key'] += 1; // Force re-render
      this.$forceUpdate();
    },
    // Note: Using this method depends on 2 conventions.
    // If tableSortName is 'myLib' then you need a table key called
    // "myLibKey" and a data property called "myLibSort"
    sortTable(tableSortName, newSortBase) {
      const sortProp = tableSortName + 'Sort';
      const oldSortBase = this[sortProp].split('-')[0];
      const oldSortDir = this[sortProp].split('-')[1];
      const defaultDir = (newSortBase === 'name' || newSortBase === 'title' || newSortBase === 'groupName' ||
        newSortBase === 'group' || newSortBase === 'status' || newSortBase === 'assignmentStatus' || newSortBase === 'lastUpload') ?
        'd' : 'u';
      const newSortDir = (oldSortBase === newSortBase) ?
        (oldSortDir === 'd') ? 'u' : 'd'
        : defaultDir;
      const sortVal = `${newSortBase}-${newSortDir}`;

      this[sortProp] = sortVal;

      // Save to localStorage
      const newSort = {};
      newSort[sortProp] = this[sortProp];
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, newSort)
      );

      // Force an update
      this[tableSortName + 'Key'] += 1; // Force re-render
      this.$forceUpdate();
    },
    sortAssignments(assignments) {
      let bucket1 = []; // First, all the active assignments
      let bucket2 = []; // Then, completed non-continuous ones
      let bucket3 = []; // Finally, disabled ones

      for (let i=0; i<assignments.length; i++) {
        const a = assignments[i];
        if (!a.sortOrder) {
          a.sortOrder = this.moment(a.createdDate).unix();
        }
        if (a.archived === true) {
          bucket3.push(a);
        } else if (
          (typeof a.assignmentAssignedCount !== 'undefined') &&
          (a.assignmentAssignedCount == a.assignmentCompletedCount &&
          (!a.groupTargets || !a.groupTargets.length))) {
          bucket2.push(a);
        } else {
          bucket1.push(a);
        }
      }

      // Sort each bucket then combine them
      bucket1 = this._.sortBy(bucket1, 'sortOrder').reverse();
      bucket2 = this._.sortBy(bucket2, 'sortOrder').reverse();
      bucket3 = this._.sortBy(bucket3, 'sortOrder').reverse();

      return this._.reverse(bucket1).concat(
        this._.reverse(bucket2),
        this._.reverse(bucket3)
      );
    },
    sortCollection(collection, sortVal) {
      const sortDir = sortVal.split('-')[1] == 'd' ? 'asc' : 'desc';
      try {
        switch (sortVal.split('-')[0]) {
        // Members: Coach Page, table 1
        case 'joinDate':
          return this._.orderBy(collection, ['membershipStartDate', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'lastRecordingDate':
          return this._.orderBy(collection, ['lastRecordingDate', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'assignmentCount':
          return this._.orderBy(collection, ['assignments.length', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'activeCount':
          return this._.orderBy(collection, ['totalActiveAssignments', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'recordingsCount':
          return this._.orderBy(collection, ['totalRecordings', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'sharedRecordingsCount':
          return this._.orderBy(collection, ['totalSharedRecordings', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'submittedRecordingsCount':
          return this._.orderBy(collection, ['totalSubmittedRecordings', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'totalFeedback':
          return this._.orderBy(collection, ['totalFeedback', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);

        // Members: Coach Page, table 1
        case 'assignmentName':
          return this._.orderBy(collection, [(i) => i.name.toLowerCase()], [sortDir]);
        case 'assignmentDate':
          return this._.orderBy(collection, ['createdDate'], [sortDir]);
        case 'totalAssRecordings':
          return this._.orderBy(collection, ['recordings.length', 'name'], [sortDir, 'desc']);
        case 'submitted':
          return this._.orderBy(collection, ['numSubmittedRecordings', 'name'], [sortDir, 'desc']);
        case 'assignmentStatus':
          return this._.orderBy(collection, ['completionStatus.status', 'name'], [sortDir, 'desc']);

        // Members: Ass Preview
        case 'name':
          return this._.orderBy(collection, [(i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, sortDir]);
        case 'status':
          return this._.orderBy(collection, ['completionStatus.status', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'lastUpload':
          return this._.orderBy(collection, ['lastUpload', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'recordings':
          return this._.orderBy(collection, ['recordings.length', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'sharedRecordings':
          return this._.orderBy(collection, ['sharedRecordings', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'submittedRecordings':
          return this._.orderBy(collection, ['submittedRecordings', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);
        case 'comments':
          return this._.orderBy(collection, ['feedbackCount', (i) => i.lastName.toLowerCase(), (i) => i.firstName.toLowerCase()], [sortDir, 'asc', 'asc']);

        // Recordings
        case 'title':
          return this._.orderBy(collection, [(i) => i.title.toLowerCase(), 'createdDate'], [sortDir, sortDir]);
        case 'group':
          return this._.orderBy(collection, [(i) => i.groupName.toLowerCase(), 'createdDate'], [sortDir, sortDir]);
        case 'uploaded':
          return this._.orderBy(collection, ['createdDate'], [sortDir]);
        case 'duration':
          return this._.orderBy(collection, ['duration', 'createdDate'], [sortDir, sortDir]);
        case 'overall':
          return this._.orderBy(collection, ['results.scores.overall', 'createdDate'], [sortDir, sortDir]);
        case 'recordingComments':
          return this._.orderBy(collection, ['feedbackCount', 'createdDate'], [sortDir, sortDir]);
        case 'rating':
          return this._.orderBy(collection, ['scoreOverallAvgRating', 'createdDate'], [sortDir, sortDir]);
        case 'coachRating':
          return this._.orderBy(collection, ['scoreOverallAvgRatingCoach', 'createdDate'], [sortDir, sortDir]);

        // Admin Manage Groups
        case 'groupName':
          return this._.orderBy(collection, [(i) => i.name.toLowerCase()], [sortDir]);
        case 'activeUsers':
          return this._.orderBy(collection, [(i) => this.countUsers(i, 'active')], [sortDir]);
        case 'totalUsers':
          return this._.orderBy(collection, [(i) => this.countUsers(i)], [sortDir]);
        case 'since':
          return this._.orderBy(collection, ['createdDate'], [sortDir]);

        // End switch case
        }

      } catch (err) {
        console.error(err);
      }
      return collection;
    },
    isRowShown(subtableId, rowId) {
      return !!(this.tableRowIndices[subtableId] && this.tableRowIndices[subtableId][rowId]);
    },
    expandRow(tableId, subtableId, rowId) {
      if (!this.tableRowIndices[subtableId]) {
        this.tableRowIndices[subtableId] = {};
      }
      if (this.tableRowIndices[subtableId][rowId]) {
        delete this.tableRowIndices[subtableId][rowId];
      } else {
        this.tableRowIndices[subtableId][rowId] = 1;
      }

      // Increment the tableId to force a refresh
      this[tableId] += 1;
      this.$forceUpdate();

      // Persist state
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {tableRowIndices: this.tableRowIndices})
      );
    },
  }
};
